"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/web.timers.js");

var _dom = require("element-ui/lib/utils/dom");

var _util = require("element-ui/lib/utils/util");

var _vdom = require("element-ui/lib/utils/vdom");

var _vuePopper = _interopRequireDefault(require("element-ui/lib/utils/vue-popper"));

var _debounce = _interopRequireDefault(require("throttle-debounce/debounce"));

var _vue = _interopRequireDefault(require("vue"));

var _default2 = {
  name: 'ElTooltip',
  mixins: [_vuePopper["default"]],
  props: {
    openDelay: {
      type: Number,
      "default": 0
    },
    disabled: Boolean,
    manual: Boolean,
    effect: {
      type: String,
      "default": 'dark'
    },
    arrowOffset: {
      type: Number,
      "default": 0
    },
    popperClass: String,
    content: String,
    visibleArrow: {
      "default": true
    },
    transition: {
      type: String,
      "default": 'el-fade-in-linear'
    },
    popperOptions: {
      "default": function _default() {
        return {
          boundariesPadding: 10,
          gpuAcceleration: false
        };
      }
    },
    enterable: {
      type: Boolean,
      "default": true
    },
    hideAfter: {
      type: Number,
      "default": 0
    },
    // 扩展v-tooltip 指定是否支持传入HTML字符串
    dangerouslyUseHTMLString: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      timeoutPending: null,
      intervalTip: null
      /** 扩展 修复引用消失，tooltip不消失bug */
      ,
      focusing: false
    };
  },
  computed: {
    tooltipId: function tooltipId() {
      return "el-tooltip-".concat((0, _util.generateId)());
    }
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    if (this.$isServer) return;
    this.popperVM = new _vue["default"]({
      data: {
        node: ''
      },
      render: function render(h) {
        return this.node;
      }
    }).$mount();
    this.debounceClose = (0, _debounce["default"])(200, function () {
      return _this.handleClosePopper();
    });
  },
  render: function render(h) {
    var _this2 = this;

    var _vm = this;

    if (this.popperVM) {
      this.popperVM.node = h("transition", {
        "attrs": {
          "name": this.transition
        },
        "on": {
          "afterLeave": this.doDestroy
        }
      }, [h("div", {
        "on": {
          "mouseleave": function mouseleave() {
            _this2.setExpectedState(false);

            _this2.debounceClose();
          },
          "mouseenter": function mouseenter() {
            _this2.setExpectedState(true);
          }
        },
        "ref": "popper",
        "attrs": {
          "role": "tooltip",
          "id": this.tooltipId,
          "aria-hidden": this.disabled || !this.showPopper ? 'true' : 'false'
        },
        "directives": [{
          name: "show",
          value: !this.disabled && this.showPopper
        }],
        "class": ['el-tooltip__popper', 'is-' + this.effect, this.popperClass]
      }, [this.$slots.content || this.content])]);
    }

    if (!this.$slots["default"] || !this.$slots["default"].length) return this.$slots["default"];
    var vnode = (0, _vdom.getFirstComponentChild)(this.$slots["default"]);
    if (!vnode) return vnode;
    var data = vnode.data = vnode.data || {};
    data.staticClass = this.concatClass(data.staticClass, 'el-tooltip');
    return vnode;
  },
  mounted: function mounted() {
    var _this3 = this;

    this.referenceElm = this.$el;

    if (this.$el.nodeType === 1) {
      this.$el.setAttribute('aria-describedby', this.tooltipId);
      this.$el.setAttribute('tabindex', 0);
      (0, _dom.on)(this.referenceElm, 'mouseenter', this.show);
      (0, _dom.on)(this.referenceElm, 'mouseleave', this.hide);
      (0, _dom.on)(this.referenceElm, 'focus', function () {
        if (!_this3.$slots["default"] || !_this3.$slots["default"].length) {
          _this3.handleFocus();

          return;
        }

        var instance = _this3.$slots["default"][0].componentInstance;

        if (instance && instance.focus) {
          instance.focus();
        } else {
          _this3.handleFocus();
        }
      });
      (0, _dom.on)(this.referenceElm, 'blur', this.handleBlur);
      (0, _dom.on)(this.referenceElm, 'click', this.removeFocusing);
    }
  },
  watch: {
    focusing: function focusing(val) {
      if (val) {
        (0, _dom.addClass)(this.referenceElm, 'focusing');
      } else {
        (0, _dom.removeClass)(this.referenceElm, 'focusing');
      }
    }
  },
  methods: {
    show: function show() {
      this.setExpectedState(true);
      this.handleShowPopper();
    },
    hide: function hide() {
      this.setExpectedState(false);
      this.debounceClose();
    },
    handleFocus: function handleFocus() {
      this.focusing = true;
      this.show();
    },
    handleBlur: function handleBlur() {
      this.focusing = false;
      this.hide();
    },
    removeFocusing: function removeFocusing() {
      this.focusing = false;
    },
    concatClass: function concatClass(a, b) {
      if (a && a.indexOf(b) > -1) return a;
      return a ? b ? a + ' ' + b : a : b || '';
    },
    handleShowPopper: function handleShowPopper() {
      var _this4 = this;

      if (!this.expectedState || this.manual) return;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this4.showPopper = true;
      }, this.openDelay);

      if (this.hideAfter > 0) {
        this.timeoutPending = setTimeout(function () {
          _this4.showPopper = false;
        }, this.hideAfter);
      }
    },
    handleClosePopper: function handleClosePopper() {
      if (this.enterable && this.expectedState || this.manual) return;
      clearTimeout(this.timeout);

      if (this.timeoutPending) {
        clearTimeout(this.timeoutPending);
      }

      this.showPopper = false;

      if (this.disabled) {
        this.doDestroy();
      }
    },
    setExpectedState: function setExpectedState(expectedState) {
      var _this5 = this;

      if (expectedState === false) {
        clearTimeout(this.timeoutPending);
        /** 扩展 修复引用消失，tooltip不消失bug */

        clearInterval(this.intervalTip);
        /** */
      }
      /** 扩展 修复引用消失，tooltip不消失bug */


      if (expectedState === true) {
        this.intervalTip = setInterval(function () {
          if (!document.contains(_this5.referenceElm)) {
            _this5.showPopper = false;
          }
        }, 3000);
      }
      /** */


      this.expectedState = expectedState;
    }
  },
  destroyed: function destroyed() {
    var reference = this.referenceElm;
    /** 扩展 修复引用消失，tooltip不消失bug */

    if (this.intervalTip) {
      clearInterval(this.intervalTip);
    }
    /** */


    (0, _dom.off)(reference, 'mouseenter', this.show);
    (0, _dom.off)(reference, 'mouseleave', this.hide);
    (0, _dom.off)(reference, 'focus', this.handleFocus);
    (0, _dom.off)(reference, 'blur', this.handleBlur);
    (0, _dom.off)(reference, 'click', this.removeFocusing);
  }
};
exports["default"] = _default2;